import React, { useEffect, useState } from 'react'
import * as jnb from 'react-bootstrap';
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import { BsChevronDown } from 'react-icons/bs';
import CommonPost from '../../CommonUtils/CommonAxios/CommonPost';
import Sweetalert from '../../CommonUtils/CommonPopupAndAlerts/SweetAlerts';
import { config } from '../../CommonUtils/CommonUrl/CommonUrls';
import PublicHeader from '../../Header/PublicHeader';
import { CommonPageHeading } from '../../CommonUtils/CommonHeading/CommonPageHeading';
import axios from 'axios';
import { handleKeyPressAlphabets, handleKeyPressNumeric, public_url } from '../../CommonUtils/Validations/RegularExpAndVar';
// import { establishmentValidations } from '../../CommonUtils/Validations/Validations';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { useQuery } from '@tanstack/react-query';
import { establishmentValidations } from '../../CommonUtils/Validations/Validations';
export default function EstablishmentApplication() {
    let location = useLocation()
    //const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
    let RegisteredStatus = location?.state?.status

    //Date Validation 
    const today = new Date();
    const sixtyYearsAgo = new Date(today.getFullYear() - 60, today.getMonth(), today.getDate());
    const mindate = sixtyYearsAgo.toISOString().split('T')[0]; //60 years ago 
    const [AppPreviewModal, setAppPreviewModal] = useState(false)
    const Formik = useFormik({
        enableReinitialize: false,
        initialValues: {
            entryBy: RegisteredStatus ? RegisteredStatus : "OWN",
            establishmentName: "",
            postalDistrictCode: "",
            postalMadalCode: "",
            postalVillageCode: "",
            postalPincode: "",
            postalDoorNo: "",
            postalAddress: "",
            permanentDistrictCode: "",
            permanentMadalCode: "",
            permanentVillageCode: "",
            permanentPincode: "",
            permanentDoorNo: "",
            permanentAddress: "",
            managerName: "",
            managerEmail: "",
            managerMobile: "",
            managerDistrict: "",
            managerMandal: "",
            managerVillage: "",
            managerDoorNo: "",
            managerPincode: "",
            managerAddress: "",
            establishmentCategory: "",
            natureOfConstruction: "",
            dateOfCommencement: "",
            dateOfCompletion: "",
            estCostOfConstruction: "",
            constructedArea: "",
            estimationBasis: "",
            planApproval: "",
            noOfWorkers: ""
        },
        onSubmit: (values) => {
            setAppPreviewModal(true)
            console.log("values", values);
        },
        validationSchema: establishmentValidations
    })
    /************************************************** Districts for all  ************************************ ******* */
    const [showDist, setDist] = useState([])
    // const getDistDataFunction = () => {
    //     let url = config.url.BOC_URL + public_url + "listofstates";
    //     axios.get(url).then((response) => {
    //         setDist(response.data.districts);
    //     })
    // };

    const { data: StatesList } = useQuery({
        queryKey: ['ListOfstates'],
        queryFn: () => axios.get(config.url.BOC_URL + public_url + 'listofstates'),
        staleTime: 1800000, //30 Minutes
        // enabled: !!org_id, // Only fetch if org_id is truthy
    });
    console.log("StatesList",StatesList,StatesList?.data.districts)
    useEffect(() => {
        // if (StatesList?.data?.status === true) {
        setDist(StatesList?.data.districts);
        // } else if (StatesList) {
        //     setDist([])
        // }
    }, [StatesList]);
    /************************************************** Postal address ************************************ ******* */
    const [showPostalManList, setPostalManList] = useState([]);
    const [showPostDistCode, setPostDistCode] = useState("");
    const getPostMandalFunction = (e) => {
        setPostDistCode(e.target.value);
        setPostalManList(showDist.filter((val) => val.districtId === e.target.value)[0].mandals)
    };
    const [showPostVillList, setPostVillList] = useState([]);
    const getPostVillageDataFunction = (e) => {
        let url = config.url.BOC_URL + public_url + "villagenew/?distCode=" + showPostDistCode + "&&mandalCode=" + e.target.value;
        axios.get(url).then((response) => {
            setPostVillList(response.data?.APCFSS_villages);
        });
    };
    /************************************************** Permanent address ************************************ ******* */
    const [showPermntManList, setPermntManList] = useState([]);
    const [showPermntDistCode, setPermntDistCode] = useState("");
    const getPermanentMandalFunction = (e) => {
        setPermntDistCode(e.target.value);
        setPermntManList(showDist.filter((val) => val.districtId === e.target.value)[0].mandals)
    };
    const [showPermntVillList, setPermntVillList] = useState([]);
    const getPermntVillageDataFunction = (e) => {
        let villUrl = config.url.BOC_URL + public_url + "villagenew/?distCode=" + showPermntDistCode + "&&mandalCode=" + e.target.value;
        axios.get(villUrl).then((response) => {
            setPermntVillList(response.data?.APCFSS_villages);
        });
    };

    /************************************************** Manger address ************************************ ******* */
    const [showMngrManList, setMngrManList] = useState([]);
    const [showMngrDistCode, setMngrDistCode] = useState("");
    const getMngrMandalFunction = (e) => {
        setMngrDistCode(e.target.value);
        setMngrManList(showDist.filter((val) => val.districtId === e.target.value)[0].mandals)
    };
    const [showMngrVillList, setMngrVillList] = useState([]);
    const getMngrVillageDataFunction = (e) => {
        let villUrl = config.url.BOC_URL + public_url + "villagenew/?distCode=" + showMngrDistCode + "&&mandalCode=" + e.target.value;
        axios.get(villUrl).then((response) => {
            setMngrVillList(response.data?.APCFSS_villages);
        });
    };

    /************************************************** Establishment Application Submission (Post Api) ************************************ ******* */
    const SubmitApplication = (values) => {
        CommonPost.establishmentReg(values).then((res) => {
            // console.log("response>>>>>>>>>>>>",res.data)
            if (res.data !== undefined && res.data.scode === '01') {
                Sweetalert(`Successfully Registered & Your Establishment Id - ${res.data.reg_id}`, 'success')

            }
            else if (res.data.scode === '02') {
                Sweetalert(res.data.sdesc, 'warning')
            }

        })
            .catch(() => {
                console.log("error")
            });
    }
    // useEffect(() => {
    //     getDistDataFunction()
    // }, []);
    return (
        <React.Fragment>
            <PublicHeader />
            <div className="main_section"> </div>
            <CommonPageHeading heading="Application for Establishment(స్థాపన కోసం దరఖాస్తు)" />
            <jnb.Container className="outer-page-content-container" >
                <FormikProvider value={Formik}>
                    <jnb.Form onChange={Formik.handleChange} onSubmit={Formik.handleSubmit} className="form_adjust">
                        <div className="form-card-jnb" >
                            <jnb.Row className="pt-0">
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >
                                    <jnb.InputGroup className="">
                                        <label>Name of the Establishment(స్థాపన పేరు)</label>
                                        <Field type="text" className="form-control w-100 mt-1" name="establishmentName"
                                            onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                            onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                        // maxLength='30'
                                        />


                                        <ErrorMessage name="establishmentName" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                            </jnb.Row>
                            <jnb.Row className="pt-0">
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Location and Postal Address(స్థానం మరియు పోస్టల్ చిరునామా)</h1>
                                </div>

                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 mb-1'>District(జిల్లా)</label>
                                        <Field as="select" name="postalDistrictCode" className="form-control w-100 nb-1"
                                            onChange={(e) => {

                                                getPostMandalFunction(e)
                                                //  ClearFunction('madalCode','');
                                                //  ClearFunction('secretariat','');
                                                //  ClearFunction('villageCode','')
                                            }}
                                        >
                                            <option value="">--Select--</option>
                                            {showDist !== undefined && showDist.map((ds, i) => {
                                                return (<option key={i} value={ds.districtId}>{ds.distName}</option>);
                                            })}
                                        </Field>
                                        <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                        <ErrorMessage name="postalDistrictCode" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 nb-1'>Mandal(మండలం) </label>
                                        <Field as="select" name="postalMadalCode" className="form-control w-100"
                                            onChange={(e) => { //getSecretrait(e);
                                                getPostVillageDataFunction(e);
                                                // ClearFunction('secretariat','');ClearFunction('villageCode','')
                                            }}
                                        >
                                            <option value="">--Select--</option>
                                            {showPostalManList !== undefined && showPostalManList.map((ms, i) => {
                                                return (<option key={i} value={ms.mandalCode}>{ms.mandalName}</option>);
                                            })}
                                        </Field>
                                        <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                        <ErrorMessage name="postalMadalCode" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label>Village(గ్రామం)</label>
                                        <Field as="select" name="postalVillageCode" className="form-control w-100 mt-1">
                                            <option value="">--Select--</option>
                                            {showPostVillList !== undefined && showPostVillList.map((vs, i) => {
                                                return (<option key={i} value={vs.village_code}>{vs.village_name}</option>);
                                            })}

                                        </Field>
                                        <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                        <ErrorMessage name="postalVillageCode" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label>Pincode(పిన్‌కోడ్)</label>
                                        <Field type="text" className="form-control w-100 mt-1" name="postalPincode" maxLength="6"
                                            onKeyPress={(e) => handleKeyPressNumeric(e)} />
                                        <ErrorMessage name="postalPincode" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label>Door No(ఇంటి నంబర్).</label>
                                        <Field type="text" className="form-control w-100 mt-1" name="postalDoorNo" onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                            maxLength="15"
                                        // onKeyPress={(e) => allowCharsAndNumericMaxSpaces(e)}
                                        />
                                        <ErrorMessage name="postalDoorNo" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>

                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label>Address(చిరునామా)</label>
                                        <Field as="textarea" id="postalAddress" name="postalAddress" rows={1} className="form-control w-100 my-1" cols={50}
                                            onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                            maxLength="100"
                                        ></Field>
                                        <ErrorMessage name="postalAddress" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                            </jnb.Row>

                            <jnb.Row className="pt-0">
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Address for Communication ( Permanent Address) - సంప్రదించడానికి చిరునామా (శాశ్వత చిరునామా)</h1>
                                </div>

                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 mb-1'>District(జిల్లా)</label>
                                        <Field as="select" name="permanentDistrictCode" className="form-control w-100 nb-1"
                                            onChange={(e) => {

                                                getPermanentMandalFunction(e)
                                                //  ClearFunction('madalCode','');
                                                //  ClearFunction('secretariat','');
                                                //  ClearFunction('villageCode','')
                                            }}
                                        >
                                            <option value="">--Select--</option>
                                            {showDist !== undefined && showDist.map((ds, i) => {
                                                return (<option key={i} value={ds.districtId}>{ds.distName}</option>);
                                            })}
                                        </Field>
                                        <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                        <ErrorMessage name="permanentDistrictCode" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 nb-1'>Mandal(మండలం) </label>
                                        <Field as="select" name="permanentMadalCode" className="form-control w-100"
                                            onChange={(e) => { //getSecretrait(e);
                                                getPermntVillageDataFunction(e);
                                                // ClearFunction('secretariat','');ClearFunction('villageCode','')
                                            }}
                                        >
                                            <option value="">--Select--</option>
                                            {showPermntManList !== undefined && showPermntManList.map((ms, i) => {
                                                return (<option key={i} value={ms.mandalCode}>{ms.mandalName}</option>);
                                            })}
                                        </Field>
                                        <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                        <ErrorMessage name="permanentMadalCode" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label>Village(గ్రామం)</label>
                                        <Field as="select" name="permanentVillageCode" className="form-control w-100 mt-1">

                                            <option value="">--Select--</option>
                                            {showPermntVillList !== undefined && showPermntVillList.map((vs, i) => {
                                                return (<option key={i} value={vs.village_code}>{vs.village_name}</option>);
                                            })}
                                        </Field>
                                        <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                        <ErrorMessage name="permanentVillageCode" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label>Pincode(పిన్‌కోడ్)</label>
                                        <Field type="text" className="form-control w-100 mt-1" name="permanentPincode" maxLength="6" onKeyPress={(e) => handleKeyPressNumeric(e)} />
                                        <ErrorMessage name="permanentPincode" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label>Door No(ఇంటి నంబర్).</label>
                                        <Field type="text" className="form-control w-100 mt-1" name="permanentDoorNo" onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                            maxLength="15"
                                        // onKeyPress={(e) => allowCharsAndNumericMaxSpaces(e)}
                                        />
                                        <ErrorMessage name="permanentDoorNo" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>

                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label>Address(చిరునామా)</label>
                                        <Field as="textarea" name="permanentAddress" rows={1} className="form-control w-100 my-1" cols={50}
                                            onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                            maxLength="100"
                                        ></Field>
                                        <ErrorMessage name="permanentAddress" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                            </jnb.Row>
                            <jnb.Row className="pt-0">
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Name & Address of the Manager responsible for establishment(సంస్థకు బాధ్యత వహించే మేనేజర్ పేరు మరియు చిరునామా)</h1>
                                </div>

                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 mb-1'>Name(పేరు)</label>
                                        <Field type="text" name="managerName" className="form-control w-100 nb-1"
                                            onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                            onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                            maxLength='30'
                                        />

                                        <ErrorMessage name="managerName" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 mb-1'>Email(ఈమెయిల్)</label>
                                        <Field type="text" name="managerEmail" className="form-control w-100 nb-1" />

                                        <ErrorMessage name="managerEmail" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 mb-1'>Mobile No(మొబైల్ నంబర్).</label>
                                        <Field type="text" maxLength={10} name="managerMobile" className="form-control w-100 nb-1" onKeyPress={(e) => handleKeyPressNumeric(e)} />

                                        <ErrorMessage name="managerMobile" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>

                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 mb-1'>District(జిల్లా)</label>
                                        <Field as="select" name="managerDistrict" className="form-control w-100 nb-1"
                                            onChange={(e) => {
                                                getMngrMandalFunction(e);
                                                //  ClearFunction('madalCode','');
                                                //  ClearFunction('secretariat','');
                                                //  ClearFunction('villageCode','')
                                            }}
                                        >
                                            <option value="">--Select--</option>
                                            {showDist !== undefined && showDist.map((ds, i) => {
                                                return (<option key={i} value={ds.districtId}>{ds.distName}</option>);
                                            })}
                                        </Field>
                                        <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                        <ErrorMessage name="managerDistrict" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 nb-1'>Mandal(మండలం) </label>
                                        <Field as="select" name="managerMandal" className="form-control w-100"
                                            onChange={(e) => {
                                                getMngrVillageDataFunction(e);
                                                // getPostVillageDataFunction(e);
                                                // ClearFunction('secretariat','');
                                                // ClearFunction('villageCode','')
                                            }}
                                        >
                                            <option value="">--Select--</option>
                                            {showMngrManList !== undefined && showMngrManList.map((ms, i) => {
                                                return (<option key={i} value={ms.mandalCode}>{ms.mandalName}</option>);
                                            })}
                                        </Field>
                                        <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                        <ErrorMessage name="managerMandal" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label>Village(గ్రామం)</label>
                                        <Field as="select" name="managerVillage" className="form-control w-100 mt-1">
                                            <option value="">--Select--</option>
                                            {showMngrVillList !== undefined && showMngrVillList.map((vs, i) => {
                                                return (<option key={i} value={vs.village_code}>{vs.village_name}</option>);
                                            })}

                                        </Field>
                                        <BsChevronDown className='icon-inside-inputfiled' style={{ top: '35' }}></BsChevronDown>
                                        <ErrorMessage name="managerVillage" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label>Pincode(పిన్‌కోడ్)</label>
                                        <Field type="text" className="form-control w-100 mt-1" name="managerPincode" maxLength="6" onKeyPress={(e) => handleKeyPressNumeric(e)} />
                                        <ErrorMessage name="managerPincode" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label>Door No(ఇంటి నంబర్).</label>
                                        <Field type="text" className="form-control w-100 mt-1" name="managerDoorNo" onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                            maxLength="15"
                                        // onKeyPress={(e) => allowCharsAndNumericMaxSpaces(e)}
                                        />
                                        <ErrorMessage name="managerDoorNo" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>

                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label>Address(చిరునామా)</label>
                                        <Field as="textarea" name="managerAddress" rows={1} className="form-control w-100 my-1" cols={50}
                                            onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                            maxLength="100"
                                        ></Field>
                                        <ErrorMessage name="managerAddress" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                            </jnb.Row>
                            <jnb.Row className="pt-0">
                                <div className="inner-herbpage-service-title-sub">
                                    <h1>Other details(ఇతర వివరాలు)</h1>
                                </div>

                                {/* <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 mb-1'>Category of Establishment(స్థాపన వర్గం)</label>
                                        <Field type="text" name="establishmentCategory" className="form-control w-100 nb-1"
                                            onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                            onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                            maxLength='30' />

                                        <ErrorMessage name="establishmentCategory" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col> */}
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup>
                                        <label className="w-100 mb-1">
                                            Category of Establishment (స్థాపన వర్గం)
                                        </label>

                                        {/* Main Category Dropdown */}
                                        <Field
                                            as="select"
                                            name="establishmentCategory"
                                            className="form-control w-100 nb-1"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                Formik.setFieldValue("establishmentCategory", value);
                                                // if (value !== "Private") {
                                                //     Formik.setFieldValue("privateSubCategory", ""); // Reset if not private
                                                // }
                                            }}
                                        >
                                            <option value="">-- Select Category --</option>
                                            <option value="State Government">State Government(రాష్ట్ర ప్రభుత్వం)</option>
                                            <option value="State Government Undertaking">State Government Undertaking(రాష్ట్ర ప్రభుత్వ ఆధీన సంస్థ)</option>
                                            <option value="Central Government">Central Government(కేంద్ర ప్రభుత్వం)</option>
                                            <option value="State Central Government Undertaking">State Central Government Undertaking(రాష్ట్ర కేంద్ర ప్రభుత్వం ఉపక్రమం)</option>
                                            <option value="Private-Residential">Private-Residential(ప్రైవేట్-నివాసం)</option>
                                            <option value="Private-Commercial">Private-Commercial(ప్రైవేట్-వాణిజ్య)</option>

                                        </Field>

                                        <ErrorMessage
                                            name="establishmentCategory"
                                            component="div"
                                            className="text-error"
                                        />
                                        {/* Subcategory shown only when Private is selected */}
                                        {/* {Formik.values.establishmentCategory === "Private" && (
                                            <>
                                                <label className="w-100 mt-2 mb-1">Private Type</label>
                                                <Field
                                                    as="select"
                                                    name="privateSubCategory"
                                                    className="form-control w-100 nb-1"
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        Formik.setFieldValue("establishmentCategory", value);
                                                    }}
                                                >
                                                    <option value="">-- Select Private Type --</option>
                                                    <option value="private-Residential">Residential</option>
                                                    <option value="private-Commercial">Commercial</option>
                                                </Field>

                                                <ErrorMessage
                                                    name="privateSubCategory"
                                                    component="div"
                                                    className="text-error"
                                                />
                                            </>
                                        )} */}
                                    </jnb.InputGroup>
                                </jnb.Col>
                                {/* <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 mb-1'>Nature of Construction(నిర్మాణ స్వభావం)</label>
                                        <Field type="text" name="natureOfConstruction" className="form-control w-100 nb-1"
                                            onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                                            onKeyPress={(e) => handleKeyPressAlphabets(e)}
                                            maxLength='30' />
                                        <ErrorMessage name="natureOfConstruction" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col> */}
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup>
                                        {/* <label className="w-100 mb-1">Nature of Construction (నిర్మాణ స్వభావం)</label> */}
                                        <label className="w-100 mb-1">Nature of Work (పనుల స్వభావం)</label>
                                        <Field
                                            as="select"
                                            name="natureOfConstruction"
                                            className="form-control w-100 nb-1"
                                        >
                                            <option value="">--Select Nature of Work --</option>
                                            <option value="Construction">Construction(నిర్మాణం)</option>
                                            <option value="Alteration">Alteration(మార్పు)</option>
                                            <option value="Repair">Repair(బాగుచేయడం)</option>
                                            <option value="Maintenance">Maintenance(నిర్వహణ)</option>
                                            <option value="Demolishing">Demolishing(కూల్చివేత)</option>
                                        </Field>
                                        <ErrorMessage name="natureOfConstruction" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 mb-1'> Date of Commencement of Construction(నిర్మాణ ప్రారంభ తేదీ)</label>
                                        {/* <Field type="Date" name="dateOfCommencement" className="form-control w-100 nb-1" mindate={mindate} /> */}
                                        <Field
                                            type="date"
                                            className="form-control w-100 mt-1"
                                            name="dateOfCommencement"
                                            value={Formik.values.dateOfCommencement}
                                            min={mindate}
                                            // max={today}
                                            onChange={(e) => {
                                                const newDate = e.target.value;
                                                Formik.setFieldValue('dateOfCommencement', newDate); // Update Formik
                                            }}
                                        />
                                        <ErrorMessage name="dateOfCommencement" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>

                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 mb-1'>Probable Date of Completion(పూర్తి అయ్యే వీలున్న తేదీ)</label>
                                        {/* <Field type="Date" name="dateOfCompletion" className="form-control w-100 nb-1" /> */}
                                        <Field
                                            type="date"
                                            className="form-control w-100 mt-1"
                                            name="dateOfCompletion"
                                            value={Formik.values.dateOfCompletion}
                                            min={mindate}
                                            // max={today}
                                            onChange={(e) => {
                                                const newDate = e.target.value;
                                                Formik.setFieldValue('dateOfCompletion', newDate); // Update Formik

                                            }}
                                        />

                                        <ErrorMessage name="dateOfCompletion" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 mb-1'>Estimated Cost of Construction(నిర్మాణ అంచనా ఖర్చు)</label>
                                        <Field type="text" name="estCostOfConstruction" className="form-control w-100 nb-1" maxLength="15"
                                            onKeyPress={(e) => handleKeyPressNumeric(e)} />

                                        <ErrorMessage name="estCostOfConstruction" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 mb-1'>Constructed area(plinth area in sq. Mts)- నిర్మిత విస్తీర్ణం (ప్లింత్ ఎరియా చదరపు మీటర్లలో)</label>
                                        <Field type="text" name="constructedArea" className="form-control w-100 nb-1" maxLength="10"
                                            onKeyPress={(e) => handleKeyPressNumeric(e)} />

                                        <ErrorMessage name="constructedArea" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className=' w-100 mb-1'>Basis for estimation(అంచనా యొక్క ఆధారం)</label>
                                        <Field type="text" name="estimationBasis" className="form-control w-100 nb-1" onKeyPress={(e) => handleKeyPressNumeric(e)} />

                                        <ErrorMessage name="estimationBasis" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className='w-100 mb-1'>Plan Approval No(ప్రణాళిక అనుమతి సంఖ్య).</label>
                                        <Field type="text" name="planApproval" className="form-control w-100 nb-1" onKeyPress={(e) => handleKeyPressNumeric(e)} />

                                        <ErrorMessage name="planApproval" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-1">
                                    <jnb.InputGroup className="">
                                        <label className='w-100 mb-1'>No. of workers(కార్మికుల సంఖ్య)</label>
                                        <Field type="number" className="form-control w-100 nb-1" name="noOfWorkers" />
                                        {/* Male
                                            <Field type="number" className="form-control" name="districtCode" />
                                            Female
                                            <Field type="number" className="form-control" name="districtCode" />
                                            Total
                                            <Field type="number" className="form-control" name="districtCode" />
                                            </label>
                                            <ErrorMessage name="districtCode" component="div" className="text-error" /> */}
                                        <ErrorMessage name="noOfWorkers" component="div" className="text-error" />
                                    </jnb.InputGroup>
                                </jnb.Col>
                            </jnb.Row>

                        </div>
                        <div className='text-end mt-0'>
                            <button type="submit" className="btn btn-success btn-md" > Preview </button>
                        </div>
                    </jnb.Form>
                </FormikProvider>
            </jnb.Container>
            <jnb.Modal show={AppPreviewModal} onHide={() => setAppPreviewModal(false)} size="xl" scrollable>
                <jnb.Modal.Header closeButton>
                    <jnb.Modal.Title className="w-100 text-center">Preview Details</jnb.Modal.Title>
                </jnb.Modal.Header>
                <jnb.Modal.Body>
                    <h5 style={{ textAlign: 'center', whiteSpace: 'pre-line', color: '#074079' }} >
                        <strong>
                            Application for Establishment(స్థాపన కోసం దరఖాస్తు)
                        </strong>
                    </h5>
                    <div className="personal-row personal-roweducation">
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                                <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                    <tr>
                                        <td>Name of the Establishment(స్థాపన పేరు):</td>
                                        <th>{Formik.values.establishmentName}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="inner-herbpage-service-title-sub">
                        <h1>Location and Postal Address(స్థానం మరియు పోస్టల్ చిరునామా)</h1>
                    </div>
                    <div className="personal-row personal-roweducation">
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                                <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                    <tr>
                                        <td>District(జిల్లా):</td>
                                        <th>{showDist?.find(v => v.districtId == Formik.values.postalDistrictCode)?.distName || ''}</th>
                                        <td>Mandal(మండలం):</td>
                                        <th>{showPostalManList?.find(v => v.mandalCode == Formik.values.postalMadalCode)?.mandalName || ''}</th>
                                    </tr><tr>
                                        <td>Village(గ్రామం):</td>
                                        <th>{showPostVillList?.find(v => v.village_code == Formik.values.postalVillageCode)?.village_name || ''}</th>
                                        <td>Pincode(పిన్‌కోడ్):</td>
                                        <th>{Formik.values.postalPincode}</th>
                                    </tr>
                                    <tr>
                                        <td>Door No(ఇంటి నంబర్).:</td>
                                        <th>{Formik.values.postalDoorNo}</th>
                                        <td>Address(చిరునామా):</td>
                                        <th>{Formik.values.postalAddress}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="inner-herbpage-service-title-sub">
                        <h1>Address for Communication ( Permanent Address) - సంప్రదించడానికి చిరునామా (శాశ్వత చిరునామా)</h1>
                    </div>
                    <div className="personal-row personal-roweducation">
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                                <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                    <tr>
                                        <td>District(జిల్లా):</td>
                                        <th>{showDist?.find(v => v.districtId == Formik.values.permanentDistrictCode)?.distName || ''}</th>
                                        <td>Mandal(మండలం):</td>
                                        <th>{showPermntManList?.find(v => v.mandalCode == Formik.values.permanentMadalCode)?.mandalName || ''}</th>
                                    </tr><tr>
                                        <td>Village(గ్రామం):</td>
                                        <th>{showPermntVillList?.find(v => v.village_code == Formik.values.permanentVillageCode)?.village_name || ''}</th>
                                        <td>Pincode(పిన్‌కోడ్):</td>
                                        <th>{Formik.values.permanentPincode}</th>
                                    </tr>
                                    <tr>
                                        <td>Door No(ఇంటి నంబర్).:</td>
                                        <th>{Formik.values.permanentDoorNo}</th>
                                        <td>Address(చిరునామా):</td>
                                        <th>{Formik.values.permanentAddress}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="inner-herbpage-service-title-sub">
                            <h1>Name & Address of the Manager responsible for establishment(సంస్థకు బాధ్యత వహించే మేనేజర్ పేరు మరియు చిరునామా)</h1>
                        </div>
                        <div className="personal-row personal-roweducation">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                        <tr>
                                            <td>Name(పేరు):</td>
                                            <th>{Formik.values.managerName}</th>
                                            <td>Email(ఈమెయిల్):</td>
                                            <th>{Formik.values.managerEmail}</th>
                                        </tr><tr>
                                            <td>Mobile No(మొబైల్ నంబర్):</td>
                                            <th>{Formik.values.managerMobile}</th>
                                            <td>District(జిల్లా):</td>
                                            <th>{showDist?.find(v => v.districtId == Formik.values.managerDistrict)?.distName || ''}</th>
                                        </tr>
                                        <tr>
                                            <td>Mandal(మండలం):</td>
                                            <th>{showMngrManList?.find(v => v.mandalCode == Formik.values.managerMandal)?.mandalName || ''}</th>
                                            <td>Village(గ్రామం):</td>
                                            <th>{showMngrVillList?.find(v => v.village_code == Formik.values.managerVillage)?.village_name || ''}</th>
                                        </tr><tr>
                                            <td>Pincode(పిన్‌కోడ్):</td>
                                            <th>{Formik.values.managerPincode}</th>
                                            <td>Door No(ఇంటి నంబర్).:</td>
                                            <th>{Formik.values.managerDoorNo}</th>
                                        </tr>
                                        <tr>
                                            <td>Address(చిరునామా):</td>
                                            <th colspan={3}>{Formik.values.managerAddress}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="inner-herbpage-service-title-sub">
                            <h1>Other establishments(ఇతర సంస్థలు)</h1>
                        </div>
                        <div className="personal-row personal-roweducation">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <tbody style={{ textAlign: "left", fontSize: "15px" }}>
                                        <tr>
                                            <td>Category of Establishment(స్థాపన వర్గం):</td>
                                            <th>{Formik.values.establishmentCategory}</th>
                                            <td>Nature of Work(పనుల స్వభావం):</td>
                                            <th>{Formik.values.natureOfConstruction}</th>
                                        </tr><tr>
                                            <td>Date of Commencement of Construction(నిర్మాణ ప్రారంభ తేదీ):</td>
                                            <th>{moment(Formik.values.dateOfCommencement).format("DD-MM-YYYY")}</th>
                                            <td>Probable Date of Completion(పూర్తి అయ్యే వీలున్న తేదీ):</td>
                                            <th>{moment(Formik.values.dateOfCompletion).format("DD-MM-YYYY")}</th>
                                        </tr>
                                        <tr>
                                            <td>Estimated Cost of Construction(నిర్మాణ అంచనా ఖర్చు):</td>
                                            <th>{Formik.values.estCostOfConstruction}</th>
                                            <td>Constructed area(plinth area in sq. Mts)- నిర్మిత విస్తీర్ణం (ప్లింత్ ఎరియా చదరపు మీటర్లలో):</td>
                                            <th>{Formik.values.constructedArea}</th></tr><tr>
                                            <td>Basis for estimation(అంచనా యొక్క ఆధారం):</td>
                                            <th>{Formik.values.estimationBasis}</th>
                                            <td>Plan Approval No(ప్రణాళిక అనుమతి సంఖ్య):</td>
                                            <th>{Formik.values.planApproval}</th>
                                        </tr>
                                        <tr>
                                            <td>No. of workers(కార్మికుల సంఖ్య):</td>
                                            <th>{Formik.values.noOfWorkers}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </jnb.Modal.Body>
                <jnb.Modal.Footer className='mb-4'>
                    <button
                        className="btn btn-secondary"
                        onClick={() => {
                            setAppPreviewModal(false);
                            document.getElementById("form-start").scrollIntoView({ behavior: "smooth" });
                        }}
                    >
                        Edit
                    </button>

                    <button
                        type="submit"
                        className="btn btn-success"
                        onClick={() => {
                            SubmitApplication(Formik.values);
                        }}
                    >
                        Submit
                    </button>
                </jnb.Modal.Footer>
            </jnb.Modal>
        </React.Fragment>

    )
}
